/**
 * Hero slider — autoplay carousel with prev/next, counter and play/pause.
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initHero = (hero) => {
    const track = hero.querySelector('[data-hero-track]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;

    const prevBtn = hero.querySelector('[data-hero-prev]');
    const nextBtn = hero.querySelector('[data-hero-next]');
    const toggleBtn = hero.querySelector('[data-hero-toggle]');
    const currentEl = hero.querySelector('[data-hero-current]');
    const ring = hero.querySelector('[data-hero-ring]');
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));

    // Restart the progress ring animation (fills over one interval).
    const restartRing = () => {
      if (!ring) return;
      ring.classList.remove('is-running');
      void ring.getBoundingClientRect(); // force reflow so the animation replays
      if (playing) ring.classList.add('is-running');
    };

    const interval = Math.max((parseInt(hero.dataset.interval, 10) || 6) * 1000, 2000);
    let index = 0;
    let timer = null;
    let playing = hero.dataset.autoplay === 'true' && !reduceMotion;

    const render = () => {
      track.style.transform = `translateX(-${index * 100}%)`;
      if (currentEl) currentEl.textContent = index + 1;
      slides.forEach((s, i) => s.setAttribute('aria-hidden', i === index ? 'false' : 'true'));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      restartRing();
    };

    const go = (n) => {
      index = (n + slides.length) % slides.length;
      render();
    };

    const stop = () => {
      if (timer) { clearInterval(timer); timer = null; }
    };
    const start = () => {
      stop();
      if (playing) timer = setInterval(() => go(index + 1), interval);
    };

    const setPlaying = (next) => {
      playing = next;
      hero.classList.toggle('is-paused', !playing);
      if (toggleBtn) {
        toggleBtn.setAttribute('aria-pressed', String(playing));
        toggleBtn.setAttribute('aria-label', playing ? 'Pausar' : 'Reproducir');
      }
      start();
      restartRing();
    };

    if (prevBtn) prevBtn.addEventListener('click', () => { go(index - 1); if (playing) start(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { go(index + 1); if (playing) start(); });
    if (toggleBtn) toggleBtn.addEventListener('click', () => setPlaying(!playing));
    dots.forEach((dot, i) => dot.addEventListener('click', () => { go(i); if (playing) start(); }));

    // Pause autoplay (and freeze the ring) while hovering / focusing; on leave
    // restart timer + ring together so they stay in sync.
    const holdAutoplay = () => { stop(); hero.classList.add('is-ring-paused'); };
    const resumeAutoplay = () => {
      hero.classList.remove('is-ring-paused');
      if (playing) { start(); restartRing(); }
    };
    hero.addEventListener('mouseenter', holdAutoplay);
    hero.addEventListener('mouseleave', resumeAutoplay);
    hero.addEventListener('focusin', holdAutoplay);
    hero.addEventListener('focusout', resumeAutoplay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) holdAutoplay(); else resumeAutoplay();
    });

    // Basic swipe (touch).
    let startX = null;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); if (playing) start(); }
      startX = null;
    }, { passive: true });

    render();
    setPlaying(playing);
  };

  const boot = () => document.querySelectorAll('[data-hero]').forEach(initHero);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (e) => {
    const hero = e.target.querySelector('[data-hero]');
    if (hero) initHero(hero);
  });
})();
